import { useAuth } from 'context/auth'
import AuthRoutes from './auth-routes'
import OnboardOrganisationRoutes from './onboard-organisation-routes'
import OrganisationRoutes from './organisation-routes'
import PublicRoutes from './public-routes'
import SetupRoutes from './setup-routes'

const Routes = () => {
  const { currentUser } = useAuth()
  const routes = PublicRoutes

  // PUBLIC - No user logged in
  if (!currentUser) {
    console.log('→ Auth routes (Login/Signup)')
    return routes.concat(AuthRoutes)
  }

  // ONBOARDING - Step 1: Create the organisation (no account exists yet).
  // The account is created by the legacy register page; POST /account now seeds
  // account.onboarding, so the next render routes into the new setup wizard.
  if (!currentUser.account) {
    console.log('→ Onboarding Step 1 (No account)')
    return routes.concat(OnboardOrganisationRoutes)
  }

  // NEW SETUP WIZARD - account exists and the wizard is not yet complete.
  if (
    currentUser.account?.onboarding &&
    !currentUser.account.onboarding.completedAt
  ) {
    console.log('→ Setup wizard')
    return routes.concat(SetupRoutes)
  }

  // LEGACY ONBOARDING - existing accounts without account.onboarding that have
  // not finished the old 3-step flow stay on the legacy flow.
  if (!currentUser.account?.onboarding && currentUser.onBoardingStep < 3) {
    console.log('→ Legacy onboarding (onBoardingStep < 3)')
    return routes.concat(OnboardOrganisationRoutes)
  }

  // DASHBOARD - Onboarding complete (wizard finished, or legacy account at step >= 3)
  console.log('→ Dashboard')
  return routes.concat(OrganisationRoutes)
}

export default Routes
